namespace GeniuzPOS.PosShift {
    export class PsPosShiftControlViewColumns {
        static columnsKey = 'PosShift.PsPosShiftControlView';
    }
}
